module.exports = __webpack_public_path__ + "img/2-4.0db7c827.png";